<!--
 * @Description: 系统指标页面
 * @Author: laoliu,wanqian
 * @Date: 2021-01-17 22:43:52
-->
<template>
  <sys-index />
</template>

<script>
export default {
  mounted() {
    this.$emit("breadcrumb", {text1: '系统管理', text2: '系统指标'});
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sysmng/SysIndex.vue